<template>
  <div class="docs-search">
    <div class="docs-search-form">
      <a-input-search
        :placeholder="$t('docs_search_placeholder')"
        :enter-button="$t('docs_search_button')"
        size="large"
        class="docs-search-input"
        v-model="searchValue"
        v-bind="$attrs"
        v-on="$listeners"
        :disabled="loading"
      />
    </div>
    <div class="docs-search-category">
      <span class="docs-search-category-title">{{ $t('docs_category_title') }}</span>
      <a-checkbox-group
        v-model="categoryValue"
        name="checkCategory"
        :options="categoryList"
        @change="onCategoryCheck"
        :disabled="loading"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Docs',
  props: {
    categoryList: {
      type: [Array],
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      categoryValue: [],
      // searchValue
      searchValue: '',
      list: [],
    };
  },
  watch: {
    categoryList(val) {
      this.list = val || [];
    },
  },
  created() {
    const { keyword, category } = this.$route.query;
    this.categoryValue = category ? category.split(',').map(item => Number(item)) : [];
    this.searchValue = keyword || '';
  },
  methods: {
    // 分类选择
    onCategoryCheck(checkedValues) {
      this.categoryValue = checkedValues;
      this.$emit('getCategoryValue', checkedValues);
    },
  },
};
</script>
<style lang="less" scoped>
.docs-search {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 16px;

  .docs-search-form {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;

    .docs-search-input {
      max-width: 560px;
    }
  }

  .docs-search-category {
    color: rgba(0, 0, 0, 0.88);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .docs-search-category-title {
      padding-right: 16px;
      font-weight: bold;
      color: #333;
      white-space: nowrap;
    }
  }
}
</style>
